import { DescriptionChapter } from '@/entities/catalog-inside-page/DescriptionChapter/ui/DescriptionChapter'
import './ui/DescriptionChapter.css'
export default DescriptionChapter
